module.exports = __webpack_public_path__ + "img/img31.07b83de9.svg";